<template>
    <div class="field-container cta-field field-text">
        <div class="form-group">
            <label class="field-label" :for="field_id">{{ form_label }}</label>
            <select :id="field_id" v-model="input" class="form-control" :disabled="disabled" :class="{ 'is-invalid': v.$error, 'is-valid': !v.$error && !v.$invalid && input }">
                <option value="">{{ $t('i18n.chooseAnOption') }}</option>
                <option :value="option" v-for="(option, index) in options" :key="index">{{ option }}</option>
            </select>
            <div class="invalid-feedback" key="required" v-if="!v.required">{{ $t('i18n.fieldIsRequired') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: "",
        },
        v: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        field_id: {
            type: String,
            required: true,
        },
    },
    computed: {
        form_label: function () {
            return this.field.label;
        },
        options: function () {
            return this.field.value;
        },
        input: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            },
        },
    }
};
</script>